import Vue from 'vue';
import Axios from 'axios';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';

const state = {
  isBusy: false,
  data: [],
  error: null // status
}

const mutations = {
  SET_STATES_BUSY: (state, payload) => {
    state.isBusy = payload;
  },
  SET_STATES_SUCCESS: (state, payload) => {
    state.data = [];
    state.data = payload.filter(item => item.state && item.state.trim().length); // remove empty ones
    state.error = null;
  },
  SET_STATES_FAIL: (state, payload) => {
    state.data = null;
    state.error = payload;
  }
}

const actions = {
  lookupStates: ({ commit, state, rootState }, stateKey) => {

    return new Promise((resolve, reject) => {

      if(state.isBusy) return reject('busy')

      commit('SET_STATES_BUSY', true);

      const { accessToken } = rootState.user.user.data;

      const config = {
        headers: { Authorization: `Token token=${accessToken}` }
      };

      // Axios.get(`${API_HOST}/countries/${stateKey}/states`, config)
      Axios.get(`${API_HOST}/lookups/countries/${stateKey}/states`, config)
        .then(({ data: { data } }) => {
          commit('SET_STATES_SUCCESS', data)
          resolve(data)
        })
        .catch(({ response }) => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error') || ''
          });
          commit('SET_STATES_FAIL', response.status);
          reject(response);
        })
        .finally(() => commit('SET_STATES_BUSY', false));
    })
  }
};

export default {
  state,
  mutations,
  actions
};